import { ReactElement } from "react";
import { useTranslation } from "@shared/utils/internationalization";
import Button from "@ui-kit/form/Button/Button.web";
import { QuantitySelectButtonProps } from "./QuantitySelectButton.props";

export default function QuantitySelectButton(
  props: QuantitySelectButtonProps
): ReactElement {
  const { t } = useTranslation("common");
  const { dataTestId, isDisabled, callbackFunc } = props;

  return (
    <Button
      w="100%"
      data-testid={dataTestId ?? "quantity-select-button"}
      colorPalette="primary"
      variant="outline"
      isDisabled={isDisabled}
      onClick={callbackFunc}
    >
      {t("Select")}
    </Button>
  );
}
